// src/components/modal/ModalMsgYesNo.js
import React from 'react';
import { FiHelpCircle } from 'react-icons/fi';
import ModalContainer from '../modalForm/ModalContainer';
import ModalHeader from '../modalForm/ModalHeader';
import ModalBody from '../modalForm/ModalBody';
import ModalFooter from '../modalForm/ModalFooter';
import ModalActions, { ModalActionButton } from '../modalForm/ModalActions';
import './ModalMsgYesNo.css';

const ModalMsgYesNo = ({ message, isOpen, resolve, focusOn = 'yes' }) => {
    // Adicionei onClose como dependência
    // O ModalContainer mantém o fechamento atualizado e controla o foco e o Escape.
    const handleClose = () => resolve(false);

    return (
        <ModalContainer
            show={isOpen}
            largura="400px"
            zIndex={1066}
            variant="cadastro"
            onHide={handleClose}
            contentClassName="modal-feedback modal-feedback-confirmation"
        >
            <ModalHeader title="Confirmação" icon={FiHelpCircle} onHide={handleClose} />
            <ModalBody>
                <div className="modal-feedback-message">{message}</div>
            </ModalBody>
            <ModalFooter>
                <ModalActions>
                    <ModalActionButton action="close" onClick={handleClose} data-modal-autofocus={focusOn === 'no'}>Não</ModalActionButton>
                    <ModalActionButton action="confirm" onClick={() => resolve(true)} data-modal-autofocus={focusOn !== 'no'}>Sim</ModalActionButton>
                </ModalActions>
            </ModalFooter>
        </ModalContainer>
    );
};

export default ModalMsgYesNo;
